import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getDashboardQuery } from '../services/metricsService';
import { queryKeys } from './queryKeys';

// The server keeps its answer for five minutes, so asking sooner than that only repeats it.
const FIVE_MINUTES = 5 * 60 * 1000;

// While another range loads, the previous one stays on screen (placeholder data), so the page doesn't jump.
export const useDashboard = (days: number) => useQuery({
    queryKey: queryKeys.dashboard(days),
    queryFn: () => getDashboardQuery(days),
    staleTime: FIVE_MINUTES,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: false,           // a 403 (not on the list) or 503 (not set up) will not change by asking again
});
